import { Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';
import Logo from '../logo';
import './footer.css';

const PRIVACY_POLICY_PATH = '/inform3d/privacyPolicy';
const TERMS_PATH = '/info/termsAndConditions';

function Footer() {
    return (
        <footer className="inform__footer">
            <div className="inform__footer-content">
                <div className="inform__footer-info">
                    <div className="inform__footer-logo">
                        <Logo />
                    </div>
                    <p className="inform_footer-info__text">A brand of 3D StockPicker OOD</p>
                    <p className="inform__footer-copyright">
                        Copyright © {new Date().getFullYear()} 3D StockPicker OOD©.
                    </p>
                    <div className="inform__footer-links">
                        <Link to={TERMS_PATH}>Terms and Conditions</Link>
                        <Link to={PRIVACY_POLICY_PATH}>Privacy Policy</Link>
                    </div>
                </div>
                <div className="inform__footer-contact">
                    <p className="inform__footer-contact-title">Contact</p>
                    <div className="inform__footer-links">
                        <a
                            className="inform__footer-social-link"
                            href="https://www.linkedin.com/showcase/inform3d-3dstockpicker/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Linkedin className="sp-icon-md" />
                            <span className="inform__footer-social-link-text">Inform3D</span>
                        </a>
                    </div>
                    <div className="inform__footer-links">
                        <a href="mailto:projects@3d-stockpicker.com">projects@3d-stockpicker.com</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
